import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "h-full flex items-center justify-between navbar" };
const _hoisted_2 = ["src", "alt", "title"];
import { useUserStore } from '@/store';
import { useEcoAuthClient } from '@onetech/eco-auth-client-vue';
import Hamburger from '@/components/Hamburger.vue';
import { ROUTE } from '@/router/routes-enum';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Navbar',
    props: {
        isMenuCollapsed: { type: Boolean },
        toggleMenuCollapse: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const user = useUserStore();
        const ecoAuthClient = useEcoAuthClient();
        const logout = () => __awaiter(this, void 0, void 0, function* () {
            yield ecoAuthClient.logout();
        });
        return (_ctx, _cache) => {
            const _component_ArrowDown = _resolveComponent("ArrowDown");
            const _component_ElIcon = _resolveComponent("ElIcon");
            const _component_ElDropdownItem = _resolveComponent("ElDropdownItem");
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu");
            const _component_ElDropdown = _resolveComponent("ElDropdown");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    class: "hamburger-btn",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.toggleMenuCollapse && _ctx.toggleMenuCollapse(...args))),
                    type: "button"
                }, [
                    _createVNode(Hamburger, {
                        isActive: _ctx.isMenuCollapsed === false
                    }, null, 8, ["isActive"])
                ]),
                _createVNode(_component_ElDropdown, {
                    class: "h-full dropdown",
                    trigger: "click"
                }, {
                    dropdown: _withCtx(() => [
                        _createVNode(_component_ElDropdownMenu, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_RouterLink, {
                                    to: { name: _unref(ROUTE).PROFILE }
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_ElDropdownItem, null, {
                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                _createTextVNode(" Profile ")
                                            ])),
                                            _: 1,
                                            __: [1]
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["to"]),
                                _createVNode(_component_ElDropdownItem, {
                                    onClick: logout,
                                    divided: ""
                                }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode(" Logout ")
                                    ])),
                                    _: 1,
                                    __: [2]
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    default: _withCtx(() => {
                        var _a, _b, _c, _d;
                        return [
                            _createElementVNode("img", {
                                class: "inline-block h-full w-auto mr-1",
                                src: _unref(user).avatar,
                                alt: (_b = (_a = _unref(user).info) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : 'User',
                                title: (_d = (_c = _unref(user).info) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : 'Profile'
                            }, null, 8, _hoisted_2),
                            _createVNode(_component_ElIcon, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_ArrowDown)
                                ]),
                                _: 1
                            })
                        ];
                    }),
                    _: 1
                })
            ]));
        };
    }
});
